<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wZBLM3/images/cover.jpg?1685203881814" alt="This image is the cover for the book Living Aware & Inspired"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Living Aware & Inspired
      </h1>
      <p class="bookDescription body article font2">
        <b>“Just be who you are meant to be…”<br/><br/>An inspired life means living to your highest potential---having a healthy body, a creative mind, the ability to take full responsibility for your choices, embracing who you are, and connecting to your spiritual life.</b><br/><br/>This book can teach you how. How to strengthen and trust your intuition. How to feel, test, and balance your energy flow. And how to understand your emotions, where they come from, where they are blocked, and how to resolve those blocks.<br/><br/><b>The information is accessible and easy to understand with exercises and illustrations to help guide you.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Pankowsky, MD
      </h2>
      
      <p class="authorDescription body article">Helen Pankowsky, M.D. works as a psychiatrist who is known for using cutting edge modalities that integrate tradtional medicine with alternative methods, successfully combining medications (as little as possible) with psychotherapy, kinesiology, energy healing, holistic lifestyle education, and intuition. Dr. Pankowsky has been a Jungian based therapist, is certified in Eye Movement Desensitization and Reprocessing (EMDR), is certified in Transcutaneous Acupuncture, and has studied alternative and complementary medicine and intuition extensively. She is a Reiki master (RMT) and a long time practitioner of Tai Chi and Qi Gong. She has lectured and taught classes on Intuition, the Feminine Psyche, Dreams, Kinesiology for Accessing Inner Blocks, Bioenergy, Emotions and the Body, Sophia (The Wisdom of God) and the Psyche, and On Becoming the Authentic Self. She has also done presentations on Gender Discrimination, Inspiring Women, Motherhood, Cancer and the Bioenergy Field, and Treatments for Post Traumatic Stress Disorder. Passionate about understanding the essence of healing, she is committed to answering the questions, "what makes our life meaningful, how do we manifest our highest capacity, and how do we find peace with who we are and the life we have?" She is dedicated to making these ideas, skills, and possibilities for expanded consciousness available to all. Helen lives in San Antonio, Texas with her husband where she often looks out the window at the trees, birds, and creatures, writes poetry, creates art, does as much tai chi and qi gong as possible, and where she still works healing patients toward their well being.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?453fbd8c